<template>
  <Modal v-model="languageConfigModal" :title="languageConfigTitle" width="700" :transfer="false"
    :mask-closable="false" @on-visible-change="languageConfigChange">
    <!--运营端-->
    <template v-if="languageConfigType === 'yms'">
      <div class="flex flex-wrap mb20">
        <span class="width_80">{{ $t('key1002558') }}</span>
        <RadioGroup v-model="languageConfigValue" class="position-relative flex_1" style="top: -1px;">
          <Radio v-for="item in languageConfigList" :label="item.value" class="mr40">{{ item.name }}</Radio>
        </RadioGroup>
      </div>
    </template>
    <!--供应商、分销商端-->
    <template v-else>
      <CheckboxGroup class="flex flex-wrap resetCheckbox" v-model="languageConfigValueList" @on-change="languageCheckboxChange">
        <div class="flex flex-wrap mb20">
          <span class="red-dot width_90">{{ $t('key1002558') }}</span>
          <div class="flex flex-wrap flex_1">
            <div v-for="item in languageConfigList" :key="item.value" class="flex align-items-center mr40 mb12">
              <Checkbox :label="item.value">{{ item.name }}</Checkbox>
              <!-- 默认语种 -->
              <span
                v-if="languageConfigValueList.includes(item.value)"
                class="font-size-12 ml7 cursor"
                :class="defaultLanguage === item.value ? 'color-999' : 'themeColor'"
                @click="setDefaultLanguage(item.value)">
              {{ defaultLanguage === item.value ? $t('key1002570') : $t('key1002571') }}
            </span>
            </div>
          </div>
        </div>
      </CheckboxGroup>
    </template>
    <template #footer>
      <Button @click="languageConfigModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="languageConfigBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import {commonLocalStorage, saveErpCommonSettingParam} from "@/utils/common";

export default {
  name: 'languageConfigModal',
  mixins: [Mixin],
  props: {
    enumData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      languageConfigTitle: '',
      languageConfigModal: false,
      languageConfigType: '',
      languageConfigValue: 'CN',
      languageConfigValueList: [],
      defaultLanguage: '', // 默认语种
      languageConfigList: [],
      configParamKey: null,
      enumKey: 'LanguageEnum',
    }
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
  },
  methods: {
    // 初始化数据
    initLanguageConfigData(type, obj) {
      this.languageConfigList = [];
      this.languageConfigType = type;
      let {paramKey, paramValue} = obj;
      this.configParamKey = paramKey;
      const configItems = commonLocalStorage.getItem('saasConfigurationItems') ?? this.$store.state.saasConfigurationItems;
      let languageSetSaas = configItems?.languageSetSaas || [];
      this.languageConfigList = languageSetSaas.map((k) => {
        let setAsDefault = false;
        paramValue.map((ele) => {
          if (ele.value === k.value) {
            setAsDefault = ele.defaultLanguage || false;
          }
        })
        return {
          value: k.value,
          name: this.enumData[`${this.enumKey}_${k.code}`] || '',
          code: k.code,
          iconPath: k.iconPath,
          setAsDefault: setAsDefault
        }
      });
      if (type === 'yms') {
        this.languageConfigTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001829');
        this.languageConfigValue = paramValue[0]?.value || 'CN';
      } else {
        this.languageConfigTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001842');
        this.languageConfigValueList = paramValue.map((item) => item.value) || [];
        this.defaultLanguage = paramValue.find((item) => item.defaultLanguage)?.value || '';
      }
      this.languageConfigModal = true;
    },
    // 勾选语种变化
    languageCheckboxChange(list) {
      // 如果默认语种被取消勾选，则清空默认语种
      if (this.defaultLanguage && !list.includes(this.defaultLanguage)) {
        this.defaultLanguage = '';
      }
    },
    // 勾选中之后才能设置默认语种
    setDefaultLanguage(value) {
      if (!this.languageConfigValueList.includes(value)) {
        return;
      }
      this.defaultLanguage = value;
      this.languageConfigList.map((item) => {
        item.setAsDefault = false;
        if (item.value === value) {
          item.setAsDefault = true;
        }
      });
    },
    // 确定
    languageConfigBtn() {
      let languageList = [];
      // 处理取值
      const mapSelected = (list, values, withDefault = false) => {
        return list
          .filter(i => values.includes(i.value))
          .map(i => ({
            value: i.value,
            code: i.code,
            iconPath: i.iconPath,
            ...(withDefault ? {defaultLanguage: i.setAsDefault} : {})
          }));
      }

      if (this.languageConfigType !== 'yms') {
        if (!this.languageConfigValueList.length) {
          this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002638'));
          return false;
        }
        if (!this.defaultLanguage) {
          this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002639'));
          return false;
        }
        languageList = mapSelected(this.languageConfigList, this.languageConfigValueList, true);
      } else {
        languageList = mapSelected(this.languageConfigList, [this.languageConfigValue]);
      }
      let queryList = [
        {
          businessId: this.userInfo.merchantId,
          paramKey: this.configParamKey,
          paramValue: JSON.stringify(languageList),
        }
      ];
      saveErpCommonSettingParam(queryList).then(() => {
        this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000708'));
        this.languageConfigModal = false;
        this.$emit('updateConfigData', true);
      });
    },
    // 监听弹窗
    languageConfigChange(value) {
      if (!value) {
        this.languageConfigValue = 'CN';
        this.languageConfigValueList = [];
        this.defaultLanguage = '';
        this.configParamKey = null;
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .resetCheckbox label {
  margin: 0;
}
</style>
